const o = /* @__PURE__ */ Symbol(
  "scrollbarContextKey"
);
export {
  o as scrollbarContextKey
};
